export default __webpack_public_path__ + "static/media/icon-chevron-down.c8792428.svg";